// src/events/session.js
const SESSION_KEY = "events_session";

export function getEventsSession() {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY)); } catch { return null; }
}

export function setEventsSession(payload) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(payload));
}

export function clearEventsSession() {
  localStorage.removeItem(SESSION_KEY);
}
